<div class="flex h-screen bg-gray-50 overflow-hidden">
  <app-sidemenu [isOpen]="isSidebarOpen()" (toggle)="toggleSidebar()"></app-sidemenu>
  <div class="flex flex-col flex-1 overflow-hidden transition-all duration-300">
    <app-header (toggleSidebar)="toggleSidebar()"></app-header>
    <main class="flex-1 overflow-y-auto p-4">
      <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
  </div>
</div>